import { defineStore } from 'pinia'
import { useBestlineVideoStore } from './bestline_video';
import { useVirtualCourtStore } from './virtual_court';

export const useLiveCourtStore = defineStore('liveCourt', {
	state: () => ({
		active_court: 'scoreboard',
	}),
	getters: {
		activeCourt(state) {
			return state.active_court;
		},
		hasVideo() {
			const virtualCourtStore = useVirtualCourtStore();
			const bestlineVideoStore = useBestlineVideoStore();

			if (virtualCourtStore.fixture_in_queue && bestlineVideoStore.hasVideo(virtualCourtStore.fixture_in_queue)) {
				return true;
			}

			return false;
		}
	},
	actions: {
		setActiveCourt(payload) {
			this.active_court = payload;
		},
		checkVideo(fixture) {
			const bestlineVideoStore = useBestlineVideoStore();
			return bestlineVideoStore.hasVideo(fixture)
		}
	}
});
